import { Bell } from 'lucide-react';

const NotificationBell = ({ unreadCount, onClick, variant = 'sidebar' }) => {
  const showBadge = unreadCount > 0;
  const badgeText = unreadCount > 9 ? '9+' : unreadCount;

  if (variant === 'mobile') {
    return (
      <button
        onClick={onClick}
        className="relative text-zinc-400 hover:text-white"
        data-testid="notification-bell-mobile"
        aria-haspopup="dialog"
        aria-label={showBadge ? `Notificaciones, ${unreadCount} sin leer` : 'Notificaciones'}
      >
        <Bell className="w-5 h-5" />
        {showBadge && (
          <span aria-hidden="true" className="absolute -top-1 -right-1 w-4 h-4 bg-primary text-white text-[10px] rounded-full flex items-center justify-center">
            {badgeText}
          </span>
        )}
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-3 rounded-sm text-zinc-400 hover:bg-zinc-900 hover:text-white transition-colors"
      data-testid="notification-bell-sidebar"
      aria-haspopup="dialog"
      aria-label={showBadge ? `Notificaciones, ${unreadCount} sin leer` : undefined}
    >
      <div className="relative">
        <Bell className="w-5 h-5" />
        {showBadge && (
          <span aria-hidden="true" className="absolute -top-1 -right-1 w-4 h-4 bg-primary text-white text-xs rounded-full flex items-center justify-center">
            {badgeText}
          </span>
        )}
      </div>
      <span className="font-body text-sm">Notificaciones</span>
    </button>
  );
};

export default NotificationBell;
